import styles from "./styles.module.css"
import { useState } from "react";

import { IoCreateOutline } from "react-icons/io5";
import ModalCreateUpdateQuestion from "../ModalCreateUpdateQuestion";

export default function QuestionUpdateButton({ collectionRef, questionData, updateTableData }) {
    const [modal, setModal] = useState(false);

    return (<>
        <button title="Atualizar" onClick={() => { setModal(true) }} className={styles.updateButton}>
            <IoCreateOutline />
        </button>

        {modal && <ModalCreateUpdateQuestion updateTableData={updateTableData} setModal={setModal} collectionRef={collectionRef} questionData={questionData} update={true} />}
    </>

    );
}